import { createSlice } from '@reduxjs/toolkit'

export const showNavSlice = createSlice({
    name: 'showNav',
    initialState: {
        value: true
    },
    reducers: {
        setShowNavTrue: state => {
            state.value = true;
        },
        setShowNavFalse: state => {
            state.value = false;
        }
    }
});

export const {
    setShowNavTrue,
    setShowNavFalse
} = showNavSlice.actions;